import { Component, Input } from '@angular/core';
import { ItemCategory } from '@planone/bau365/data-access-user';

@Component({
  selector: 'bau365-watchlist-result-count',
  templateUrl: './watchlist-result-count.component.html',
  styleUrls: ['./watchlist-result-count.component.scss'],
})
export class WatchlistResultCountComponent {
  @Input() watchlistItemsCount: number | undefined | null = 0;
  @Input() itemCategory: ItemCategory | undefined | null;
}
